import NoCard from "@/views/network-card/NoCard";
import FreezeCard from "@/views/network-card/FreezeCard";
import MismatchCard from "@/views/network-card/MismatchCard";
import VerifySuccess from "@/views/network-card/VerifySuccess";
import VerifyFail from "@/views/network-card/VerifyFail";

const routes = [
    {
        path: "/noCard",
        name: "NoCard",
        meta: {
            title: "未办理网证"
        },
        component: NoCard
    },
    {
        path: "/freezeCard",
        name: "FreezeCard",
        meta: {
            title: "网证已过期"
        },
        component: FreezeCard
    },
    {
        path: "/mismatchCard",
        name: "MismatchCard",
        meta: {
            title: "设备不匹配"
        },
        component: MismatchCard
    },
    {
        path: "/verifySuccess",
        name: "VerifySuccess",
        meta: {
            title: "认证成功"
        },
        component: VerifySuccess
    },
    {
        path: "/verifyFail",
        name: "VerifyFail",
        meta: {
            title: "认证失败"
        },
        component: VerifyFail
    },
];
export default routes;
